/**
 * Singleton global pour tracker l'activité utilisateur
 * Évite les duplications d'event listeners et réduit drastiquement la charge DB
 * 
 * Stratégie optimisée :
 * - Uniquement visibilitychange (AUCUN mousemove/click/keypress)
 * - Throttle à 15 minutes (au lieu de 5)
 * - Un seul gestionnaire pour toute l'application
 */
class GlobalActivityTracker {
  private static instance: GlobalActivityTracker;
  private lastUpdate = 0;
  private updateCallback?: () => Promise<void>;
  private readonly UPDATE_INTERVAL = 900000; // 15 minutes

  private constructor() {
    // ✅ Uniquement visibilitychange - AUCUN mousemove/click/keypress
    document.addEventListener('visibilitychange', this.handleVisibility);
    console.log('🎯 Global Activity Tracker initialized - 15min interval');
  }

  static getInstance() {
    if (!GlobalActivityTracker.instance) {
      GlobalActivityTracker.instance = new GlobalActivityTracker();
    }
    return GlobalActivityTracker.instance;
  }

  setUpdateCallback(callback: () => Promise<void>) {
    this.updateCallback = callback;
  }

  private handleVisibility = async () => {
    if (!document.hidden && this.updateCallback) {
      const now = Date.now();
      // Update only if 15 minutes passed since last update
      if (now - this.lastUpdate > this.UPDATE_INTERVAL) {
        console.log('⏰ 15min passed - updating activity');
        await this.updateCallback();
        this.lastUpdate = now;
      } else {
        const remaining = Math.round((this.UPDATE_INTERVAL - (now - this.lastUpdate)) / 60000);
        console.log(`⏳ ${remaining} minutes remaining before next update`);
      }
    }
  };

  cleanup() {
    document.removeEventListener('visibilitychange', this.handleVisibility);
  }
}

export const activityTracker = GlobalActivityTracker.getInstance();
